import BaseCache from '../base/cache';
import { RequestOption } from '../base/define';
import config from './config';
import {
  WeChatSign, NosToken, YXSign, FILE_TYPE, UserGroupInfo,
} from './define/Share';

export default class SharedCache extends BaseCache {
  constructor() {
    super(config);
  }

  getWeChatSign(option: RequestOption<undefined, {encodeUrl: string}>) {
    return this.doSendRequest('get-wechat-sign', option) as Promise<WeChatSign>;
  }

  getNosToken(option: RequestOption<{num: number; ext: string}, undefined>) {
    return this.doSendRequest('get-nos-token', option) as Promise<NosToken[]>;
  }

  getNosTokenSafe(option: RequestOption<{m: string; ext: string}, undefined>) {
    return this.doSendRequest('get-nos-token-safe', option) as Promise<NosToken[]>;
  }

  getShareNosToken(option: RequestOption<{ext: string}, undefined>) {
    return this.doSendRequest('get-share-nos-token', option) as Promise<NosToken[]>;
  }

  getYXSign(option: RequestOption<undefined, {fileName: string; type?: FILE_TYPE}>) {
    return this.doSendRequest('get-yx-sign', option) as Promise<YXSign>;
  }

  getUserGroupInfo(option: RequestOption<undefined, undefined>) {
    return this.doSendRequest('get-user-group-info', option) as Promise<UserGroupInfo[]>;
  }
}
